export default {
  nav_home: 'Home',
  nav_about: 'About Us',
  nav_services: 'Services',
  nav_training: 'Training',
  nav_automotive: 'Automotive',
  nav_blog: 'Blog',
  nav_contact: 'Contact',
  
  hero_badge: 'New Era in the Industry',
  hero_title: 'AXIOM',
  hero_subtitle: 'Quality Control and Human Resources Consulting',
  hero_services_btn: 'Our Services',
  hero_contact_btn: 'Get in Touch',
  
  about_badge: 'Corporate Identity',
  about_title: 'Distinctive Consulting Services with AXIOM',
  about_description: 'We optimize your quality control processes and strengthen your human resources management. With our new entry into the sector, we are by your side with our experienced team and innovative approach. We raise quality standards and maximize your human resources potential for your business success.',
  
  services_title: 'Our Services',
  services_subtitle: 'Quality Control and Repair Services',
  service1_title: 'Control Sorting Repair and Retouch',
  service1_desc: 'Professional control, sorting, repair and retouch services',
  service2_title: 'Visual and Dimensional Controls',
  service2_desc: 'Detailed visual and dimensional quality control processes',
  service3_title: 'Firewall & CSL1 & CSL2 & CSL3',
  service3_desc: 'Security and quality level controls',
  service4_title: 'Electronic Environment & Software & Update Operations',
  service4_desc: 'Software and update services for electronic systems',
  service5_title: 'Paint and Coating Thickness Controls',
  service5_desc: 'Paint and coating thickness measurement and control services',
  service6_title: 'Destructive & Non-Destructive Controls',
  service6_desc: 'Material testing and control services',
  service_detail_btn: 'Detailed Information',
  service_custom_packages: 'Custom packages available',
  
  training_badge: 'Training Programs',
  training_title: 'Corporate Development Training',
  training_subtitle: 'Specially designed training programs for the development of your employees and organization',
  
  auto_badge: 'Our Expertise',
  auto_title: 'Automotive Supplier Quality Control',
  auto_description: 'Our team specialized in quality control of critical parts in the automotive sector is with you at every stage of your production processes. We provide error-free production guarantee with inspection and control processes in accordance with ISO/TS 16949 standards.',
  auto_quality_rate: '99.8% Quality Rate',
  auto_experience: '15+ Years Experience',
  auto_motor_title: 'Engine Parts',
  auto_motor_desc: 'Precise control and quality assurance of critical engine parts such as pistons, valves, crankshafts',
  auto_chassis_title: 'Chassis and Suspension',
  auto_chassis_desc: 'Strength tests and dimensional verification controls of carrier system parts',
  auto_electric_title: 'Electrical and Electronics',
  auto_electric_desc: 'Functional tests of cable harnesses, sensors and electronic components',
  auto_process_title: 'Our Quality Control Process',
  auto_process_desc: 'By applying detailed control protocols for each part, we help you achieve zero defect target in your production processes.',
  auto_step1_title: 'Incoming Inspection',
  auto_step1_desc: 'Raw material and semi-finished product acceptance controls',
  auto_step2_title: 'In-Process Control',
  auto_step2_desc: 'Real-time quality monitoring during production stages',
  auto_step3_title: 'Final Inspection',
  auto_step3_desc: 'Final quality approval before shipment',
  auto_stat1: 'Quality Rate',
  auto_stat2: 'Parts Inspected',
  auto_stat3: 'Business Partners',
  auto_stat4: 'Years Experience',
  
  blog_title: 'Blog & Content',
  blog_subtitle: 'Industry developments and expert opinions',
  blog_all_btn: 'All Articles',
  
  cta_title: 'start with\naxiom',
  cta_subtitle: 'Strengthen your quality and human resources processes\nwith professional consulting',
  cta_btn: 'Get a Quote',
  
  contact_title: 'Get in Touch',
  contact_subtitle: 'Contact us with your questions, we will get back to you as soon as possible.',
  contact_email: 'Email',
  contact_phone: 'Phone',
  contact_address: 'Address',
  form_name: 'Full Name',
  form_name_placeholder: 'Your name and surname',
  form_email: 'Email',
  form_email_placeholder: 'example@email.com',
  form_phone: 'Phone',
  form_phone_placeholder: '+90 (5__) ___ __ __',
  form_message: 'Your Message',
  form_message_placeholder: 'How can we help you?',
  form_submit: 'Send',
  form_submitting: 'Sending...',
  form_success: 'Your message has been sent successfully! We will get back to you as soon as possible.',
  form_error: 'An error occurred. Please try again.',
  form_validation_required: 'Please fill in all fields.',
  form_validation_email: 'Please enter a valid email address.',
  form_validation_length: 'Your message cannot be longer than 500 characters.',
  
  footer_description: 'We contribute to the success of your business with quality and trust-oriented consulting services.',
  footer_services: 'Services',
  footer_quality: 'Quality Control',
  footer_hr: 'HR Consulting',
  footer_training: 'Training',
  footer_audit: 'Audit',
  footer_corporate: 'Corporate',
  footer_about: 'About Us',
  footer_team: 'Our Team',
  footer_career: 'Career',
  footer_contact: 'Contact',
  footer_resources: 'Resources',
  footer_blog: 'Blog',
  footer_references: 'References',
  footer_faq: 'FAQ',
  footer_documents: 'Documents',
  footer_cta_title: 'Achieve\nSuccess\nTogether',
  footer_newsletter: 'Stay informed about industry developments',
  footer_email_placeholder: 'Your email address',
  footer_copyright: '© 2025 AXIOM Quality Control and Human Resources Consulting. All rights reserved.',
  footer_powered: 'Powered by Readdy'
};